import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import { User } from "interfaces/models/user";
import { axiosECS } from "services/baseAxios";
import { validateBodyReq } from "utils/common";
import { presignedAndDownloadFileS3 } from "utils/file";

const path = PATH_API.USER;

export const getUserList = async (
  params: any = {},
  shouldCache = false
): Promise<ApiResponse<User[]>> => {
  return axiosECS.get(path, {
    params: {
      shouldCache,
      ...params,
    },
  });
};

const getProfile = async (
  shouldCache?: boolean
): Promise<ApiResponse<User>> => {
  return axiosECS.get(`${path}/profiles`, {
    params: {
      // not use cache's data in service worker
      useCache: false,
      shouldCache,
    },
  });
};

export const updateProfile = async (user: User): Promise<ApiResponse<User>> => {
  return axiosECS.patch(`${path}/profiles`, validateBodyReq(user));
};

export const handleGetProfile = async (shouldCache?: boolean) => {
  const { data: user } = await getProfile(shouldCache);
  if (user && shouldCache && !!user.avatar) {
    await presignedAndDownloadFileS3(user.avatar, shouldCache);
  }

  return user;
};
